angular.module('ui2.0Controllers').controller("aiAgentsController", ["$rootScope", '$scope', "$http", '$location', '$routeParams', function ($rootScope, $scope, $http, $location, $routeParams) {
    // DEFINITIONS
    const lStorageName = 'aiAgents',
        appItemsFromLocalStorage = JSON.parse(localStorage.getItem(lStorageName)),
        servicePath = '/external',
        allAgentAppsURL = `${servicePath}/agent-applications`,
        agentAppDataURL = `${servicePath}/agent-sessions/`;

    startLoader();
    // DECLARATIONS
    // var appIdToNameMapper;

    // SCOPE DEF.
    $scope.param = $routeParams.appId;

    // DATA MASSAGING
    const getAppIdToNameMapper = data =>
        data.reduce((acc, {appId, appName}) => {
            acc[appId] = appName;
            return acc;
        }, {});

    // GET ALL AGENT APPS FOR CURRENT USER
    const getAllAgentApps = () => {
        if (!!appItemsFromLocalStorage && typeof appItemsFromLocalStorage == 'object') {
            // Early return w/o calling API
            // appIdToNameMapper = appItemsFromLocalStorage;
            return appItemsFromLocalStorage;
        } else {
            // Call API otherwise
            return $http.get(addtStamp(allAgentAppsURL))
                .then(res => {
                    // if(res.data.length == 0)
                    //     res.data = [
                    //         {
                    //             appId: 'sirion01',
                    //             appName: 'Convo Create Agent',
                    //         },
                    //         {
                    //             appId: 'contract-management',
                    //             appName: 'Contract Management',
                    //         },
                    //     ];
                    // appIdToNameMapper = getAppIdToNameMapper(res.data);
                    localStorage.setItem(lStorageName, JSON.stringify(getAppIdToNameMapper(res.data)));
                    return getAppIdToNameMapper(res.data);
                }, err => {
                    console.error("Error occured while fetching Data. Error: ", err);
                });
        }
    }

    const initAgentApp = async () => {
        let URL = window.location.href;
        const appIdToNameMapper = await getAllAgentApps(),
            appId = $routeParams.appId,
            url = decodeURIComponent(window.location.href),
            getQueryParamsFromURL = SirionUtils.getQueryParam(url)?.uaPageContext || null,
            uaPageContext = JSON.parse(getQueryParamsFromURL) || {},
            // caseId = SirionUtils.getQueryParam(url)?.caseId || null,
            pageId = uaPageContext.pageId,
            // queryParam = 'caseId',
            // validSearchParams = new Set(['project_id', 'TableId', 'page_name', 'knowledgeID', 'route', 'caseId', 'uaPageContext']),

            onPageEvent = (event) => {
                console.log('onPageEvent', event);
                // const payload = event?.eventPayload,
                // eventType = event?.eventType,
                // params = Object.keys(payload),
                delete event?.eventPayload?.pageInputs?.authToken; // Removing authToken for now since it's causing issue (redirect to login post 401 since emailAuthToken flow is triggered)
                const uaPageContext = JSON.stringify(event.eventPayload);

                URL = SirionUtils.addQueryString(URL, `uaPageContext=${uaPageContext}`, 'uaPageContext');

                // if(params.length && eventType === 'pageChange') {
                //
                //     params.forEach(param => {
                //         // if(validSearchParams.has(param)){
                //             URL = SirionUtils.addQueryString(URL, `${param}=${payload?.[param]}`, param);
                //         // }
                //     });
                window.location.href = URL;
                //
                // }

                // Set caseId in URL search Params to maintain context of widget caseIds
                // window.location.href = SirionUtils.addQueryString(window.location.href, `${queryParam}=${event?.eventPayload?.caseId}`, queryParam);
            },
            pageInputs = {
                url: window.location.origin,
                ...uaPageContext.pageInputs
            };

        console.log(uaPageContext);

        console.log(getQueryParamsFromURL);

        const isValidRouteForCurrentUser = !!appIdToNameMapper[appId];

        // Add caseId in pageInputs for context
        // if (!!caseId)
        // pageInputs.caseId = caseId;

        /**** METHODS ****/
            // GET AGENT APP DATA
        const getAgentAppData = () =>
                $http.get(addtStamp(agentAppDataURL + appId))
                    .then(res => res.data,
                        err => console.error("Error occured while fetching Data. Error: ", err)
                    ),
            // GET AUTH SERVICE URL
            getAuthBasedUrl = (baseUrl) => {
                const isAuthServiceEnabled = readCookie('authServiceEnabled');
                return isAuthServiceEnabled === 'true' ? `/auth${baseUrl}` : baseUrl;
            },
            // GET ACCESS TOKEN
            getAccessToken = async () => {
                const res = await fetch(getAuthBasedUrl("/refresh"), {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    cache: 'no-store'
                }).then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                }).then(data => {
                    pageInputs.authToken = data.accessToken;
                }).catch(error => {
                    console.error('Error getting access token', error);
                });
            },
            // INITIATE AI AGENT APPLICATION
            initiateUAApp = (host, token, applicationId, identityProviderId, pageInputs, appName, onPageEvent) => {
                window.unifyAppsSettings = {
                    host,
                    token,
                    identityProviderId,
                    applicationId,
                    pageId,
                    pageInputs,
                    onPageEvent,
                    containerEl: document.getElementById("root_ai_agents"),
                };

                console.log("Initiate UA App SDK", applicationId);
                var w = window,
                    ua = w.UnifyApps;
                if (typeof ua === 'function') {
                    ua('init', w.unifyAppsSettings);
                } else {
                    var d = document,
                        u = function () {
                            u.c(arguments);
                        };
                    u.q = [];
                    u.c = function (args) {
                        u.q.push(args);
                    };
                    w.UnifyApps = u;
                    w.UnifyApps('init');
                    var l = function () {
                        var s = d.createElement('script');
                        s.type = 'text/javascript';
                        s.async = true;
                        s.src = window.unifyAppsSettings.host + '/lib/delta-matrix/ua-web-sdk.js';
                        var x = d.getElementsByTagName('script')[0];
                        x.parentNode.insertBefore(s, x);
                    };
                    if (document.readyState === 'complete') {
                        l();
                    } else if (w.attachEvent) {
                        w.attachEvent('onload', l);
                    } else {
                        w.addEventListener('load', l, false);
                    }
                }
            };

        // IF VALID APP-ID/ROUTE, INITIATE AGENT APP
        if (isValidRouteForCurrentUser) {
            await getAccessToken();
            const agentAppData = await getAgentAppData();
            const {hostname, sessionId, appId, providerId, appName} = agentAppData;
            initiateUAApp(hostname, sessionId, appId, providerId, pageInputs, appName, onPageEvent);
            stopLoader();
        } else {
            // STOP LOADER & REDIRECT
            $scope.showInvalidRouteMsg = true;
            stopLoader();
        }
    };

    // Return early if permission is false
    const agentInitiatorInterval = setInterval(() => {
        const sideLayoutData = localStorage.getItem('sideLayoutData');
        if (sideLayoutData) {
            clearInterval(agentInitiatorInterval);
            if (!window.thirdPartyAgentApplicationEnabled) {
                console.warn('thirdPartyAgentApplicationEnabled Permission is false.');
                return false;
            } else {
                initAgentApp();
            }
        }
    }, 100);

}]);
